<div class="footer-a2a"><p class="text-xs-center" style="width: 100%; text-align: center">
  <img style="max-width: 5%;max-height: 5%" src="assets/images/logo-a2a.png">
  {{'footer'|translate}}
</p>
</div>
